import { useFeatureLoyaltyHowItWorksQuery } from 'generated/sanity-graphql';

export const useLoyaltyHowItWorks = (featureLoyaltyHowItWorksId: string) => {
  const { data, loading, error } = useFeatureLoyaltyHowItWorksQuery({
    variables: {
      featureLoyaltyHowItWorksId,
    },
    skip: !featureLoyaltyHowItWorksId,
  });

  const howItWorksContent = data?.FeatureLoyaltyHowItWorks;

  return {
    loading,
    error,
    modalHeader: howItWorksContent?.modalHeader?.locale ?? '',
    pageTitle: howItWorksContent?.pageTitle?.locale ?? '',
    pageSubtitle: howItWorksContent?.pageSubtitle?.localeRaw ?? '',
    callToActionText: howItWorksContent?.callToAction?.locale ?? '',
    steps: howItWorksContent?.howItWorksSteps || [],
  };
};
